/**
 * Phone settings section.
 *
 * Renders the Quo phone/telephony integration. Self-gated on the quo_sync
 * feature flag: when the flag is off, nothing renders and QuoIntegration's
 * data-fetching hooks never run.
 */

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { QuoIntegration } from '@/lib/integrations/quo/QuoIntegration';

export function PhoneSection() {
  const quoEnabled = useFeatureFlag('quo_sync');

  if (!quoEnabled) {
    return null;
  }

  return (
    <div className='space-y-8'>
      <div>
        <h2 className='text-lg font-semibold text-fg-primary'>Phone</h2>
        <p className='text-sm text-fg-tertiary mt-0.5'>
          Connect a telephony provider to capture calls and texts in your CRM.
        </p>
      </div>

      <div className='space-y-6'>
        <QuoIntegration />
      </div>
    </div>
  );
}
